<template>
    <div>

            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" style='width: 200px'></el-input>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>



        <div>


            <el-table
                :data="tableData"
                row-key="id"
                @selection-change="handleSelectionChange"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="协议名称" prop="title"></el-table-column>

                <el-table-column label="协议说明" prop="description"></el-table-column>

                <el-table-column label="服务方" prop="server">
                    <template slot-scope='scope'>
                        {{scope.row.server.name}}
                    </template>
                </el-table-column>

                <el-table-column label="合同" >
                    <template slot-scope="scope">
                        {{scope.row.contract.title}}
                    </template>
                </el-table-column>

                <el-table-column label="更新日期" prop="updateTime"></el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>

        </div>
        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" size="small" @click="submit" :disabled="submitBtn">确定</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </div>

    </div>
</template>

<script>
    // import Pagination from '../../../components/Pagination'
    import services from "../../services/common.service"


    export default {

        // components: { Pagination },

        props:{
            callback:Function
        },
        data() {
            return {

                loading: true,
                tableData: [],
                form: {

                    pageIndex: 1,
                    pageSize: 10,
                },
                multipleSelection: [],
                total:null,
                submitBtn:true
            }
        },

        mounted() {
            this.request()
        },

        methods: {
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            // 请求数据
            request() {
                this.tableData = []
                this.loading = true
                services.getSlaList(this.form)
                    .then(res => {
                        this.tableData = res.list
                        this.total = +res.total
                    })
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.loading = false)
            },

            // 删除数据
            deleteRole(index, rows,serialNumber) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(() => {
                    services.serviceSlaDelete({serialNumber})
                        .then(res => {
                            rows.splice(index, 1)
                            this.$message.success('删除成功！')
                        })
                        .catch(err => this.$message.error(err.message))
                })
                    .catch(() => this.$message.info('已取消删除'))
            },
            handleSelectionChange(val){
                if(val.length > 1 ){
                    this.submitBtn = true;
                    this.$message.error("只可选择一个SLA");
                }else{
                    this.multipleSelection = val;
                    this.submitBtn = false;
                }
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个SLA")
                }else{
                    // console.log(this.multipleSelection);
                    this.callback(this.multipleSelection[0]);
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            // 更新分页器页数
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request();
            },

            // 更新分页器页码
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
